// src/services/paymentService.js
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage'; // Add this import
import api from './api';

const GLOSWITCH_BASE_URL = 'https://gloswitch.com/api';
const ORGANIZATION_ID = 19;
const API_KEY = 'mjwyvy8ueampu18t';
const SECRET_KEY = 'gh68nzqtyeylgdye';
const PAYMENT_AMOUNT = 500;
const CURRENCY = 'XAF';

let authToken = null;
let tokenExpiry = null;

// Generate authentication token
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const generateAuthToken = async () => {
  await delay(1000); // 1 second delay before making the request
  try {
    console.log('🔄 Generating auth token... - paymentService.js:22');
    const response = await axios.post(`${GLOSWITCH_BASE_URL}/business-user/getOrganisationToken`, {
      apiKey: API_KEY,
      secretKey: SECRET_KEY,
      typeToken: 'LONG'
    });

    console.log('✅ Token response: - paymentService.js:29', response.data);
    
    // FIX: The response has 'bearer' field, not 'token'
    if (response.data && response.data.bearer) {
      authToken = response.data.bearer;
      // Parse the expiry date from the response
      if (response.data.expireAt) {
        tokenExpiry = new Date(response.data.expireAt);
      } else {
        // Fallback: 25 minutes from now
        tokenExpiry = new Date(Date.now() + 25 * 60 * 1000);
      }
      console.log('✅ Token generated successfully, expires: - paymentService.js:41', tokenExpiry);
      console.log('✅ Token: - paymentService.js:42', authToken.substring(0, 20) + '...'); // Log first 20 chars
      return authToken;
    }
    
    // If bearer field is not found, check for token field as fallback
    if (response.data && response.data.token) {
      authToken = response.data.token;
      tokenExpiry = new Date(Date.now() + 25 * 60 * 1000);
      console.log('✅ Token generated from token field, expires: - paymentService.js:50', tokenExpiry);
      return authToken;
    }
    
    throw new Error('Failed to generate auth token - no bearer or token in response');
  } catch (error) {
    console.error('❌ Error generating auth token: - paymentService.js:56', error.response?.data || error.message);
    console.error('❌ Full error: - paymentService.js:57', error);
    throw error;
  }
};

// Get valid auth token
const getValidAuthToken = async () => {
  const now = new Date();
  
  // Check if token exists and is not expired
  const isTokenValid = authToken && tokenExpiry && now < tokenExpiry;
  
  if (!isTokenValid) {
    console.log('🔄 Token expired or not found, generating new one... - paymentService.js:70');
    await generateAuthToken();
  } else {
    const minutesLeft = Math.round((tokenExpiry - now) / 1000 / 60);
    console.log('✅ Using existing token, expires in: - paymentService.js:74', minutesLeft, 'minutes');
  }
  
  return authToken;
};

// Initialize payment
export const initiatePayment = async (phoneNumber, paymentMethod, verificationId) => {
  try {
    console.log('🔄 Initiating payment... - paymentService.js:83');
    console.log('📱 Phone: - paymentService.js:84', phoneNumber);
    console.log('💳 Method: - paymentService.js:85', paymentMethod);
    console.log('🆔 Verification ID: - paymentService.js:86', verificationId);
    
    const token = await getValidAuthToken();
    console.log('✅ Got auth token: - paymentService.js:89', token ? `Yes (first 20 chars: ${token.substring(0, 20)}...)` : 'No');
    
    // Validate phone number format for Gloswitch
    let formattedPhone = phoneNumber.replace(/\s+/g, '');
    
    // Ensure it starts with 237
    if (!formattedPhone.startsWith('237')) {
      formattedPhone = `237${formattedPhone}`;
    }
    
    // Remove any plus signs
    formattedPhone = formattedPhone.replace('+', '');
    
    console.log('📱 Formatted phone for Gloswitch: - paymentService.js:102', formattedPhone);
    
    const requestData = {
      organizationId: ORGANIZATION_ID,
      totalAmount: PAYMENT_AMOUNT,
      phoneNumber: formattedPhone,
      currency: CURRENCY,
      paymentMethod: paymentMethod,
      callbackUrl: 'https://api.chindha.com/api/webhooks/gloswitch',
      description: `Taxi Census Payment _ Verification ID _ ${verificationId}`
    };

    console.log('📤 Sending payment request to: - paymentService.js:114', `${GLOSWITCH_BASE_URL}/business-transaction/order/payement/initiate`);
    console.log('📤 Request data: - paymentService.js:115', JSON.stringify(requestData, null, 2));
    
    // Make sure we have the token
    if (!token) {
      throw new Error('No authentication token available');
    }
    
    const response = await axios.post(
      `${GLOSWITCH_BASE_URL}/business-transaction/order/payement/initiate`,
      requestData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        timeout: 30000 // 30 second timeout
      }
    );

    console.log('✅ Payment initiated successfully: - paymentService.js:135', response.data);
    console.log('✅ Response status: - paymentService.js:136', response.status);
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('❌ Error initiating payment: - paymentService.js:143');
    console.error('❌ Error message: - paymentService.js:144', error.message);
    
    if (error.response) {
      console.error('❌ Error status: - paymentService.js:147', error.response.status);
      console.error('❌ Error data: - paymentService.js:148', error.response.data);
      console.error('❌ Error headers: - paymentService.js:149', error.response.headers);
    } else if (error.request) {
      console.error('❌ No response received: - paymentService.js:151', error.request);
    }
    
    console.error('❌ Full error: - paymentService.js:154', error);
    
    let errorMessage = 'Failed to initiate payment';
    
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.status === 401) {
        errorMessage = 'Authentication failed. Token may be invalid or expired.';
      } else if (error.response.status === 400) {
        errorMessage = 'Invalid request. Please check your information.';
      } else if (error.response.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      }
    } else if (error.request) {
      errorMessage = 'No response from server. Check your internet connection.';
    }
    
    return {
      success: false,
      error: errorMessage,
      details: error.response?.data
    };
  }
};

// Check payment status
export const checkPaymentStatus = async (orderId) => {
  try {
    console.log('🔄 Checking payment status for order: - paymentService.js:183', orderId);
    const token = await getValidAuthToken();
    
    const response = await axios.get(
      `${GLOSWITCH_BASE_URL}/business-transaction/order/status/${orderId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('✅ Payment status: - paymentService.js:196', response.data);
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('❌ Error checking payment status: - paymentService.js:203', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.message || 'Failed to check payment status'
    };
  }
};

// Store payment info in AsyncStorage
export const storePaymentInfo = async (verificationId, paymentData) => {
  try {
    const paymentInfo = {
      verificationId,
      orderId: paymentData.orderId,
      paymentToken: paymentData.paymentToken,
      phoneNumber: paymentData.phoneNumber,
      paymentMethod: paymentData.paymentMethod,
      amount: PAYMENT_AMOUNT,
      status: paymentData.status,
      timestamp: new Date().toISOString()
    };

    await AsyncStorage.setItem(`payment_${verificationId}`, JSON.stringify(paymentInfo));
    return true;
  } catch (error) {
    console.error('Error storing payment info: - paymentService.js:228', error);
    return false;
  }
};

// Get payment info from AsyncStorage
export const getPaymentInfo = async (verificationId) => {
  try {
    const paymentInfo = await AsyncStorage.getItem(`payment_${verificationId}`);
    return paymentInfo ? JSON.parse(paymentInfo) : null;
  } catch (error) {
    console.error('Error getting payment info: - paymentService.js:239', error);
    return null;
  }
};

// Check if payment is already completed for this verification
export const isPaymentCompleted = async (verificationId) => {
  try {
    const paymentInfo = await getPaymentInfo(verificationId);
    if (!paymentInfo) return false;
    
    // Also check with Gloswitch API to ensure status is correct
    const statusResult = await checkPaymentStatus(paymentInfo.orderId);
    if (statusResult.success && statusResult.data.status === 'SUCCESSFULL') {
      // Update local status if needed
      if (paymentInfo.status !== 'SUCCESSFULL') {
        paymentInfo.status = 'SUCCESSFULL';
        await storePaymentInfo(verificationId, paymentInfo);
      }
      return true;
    }
    
    return paymentInfo.status === 'SUCCESSFULL';
  } catch (error) {
    console.error('Error checking payment completion: - paymentService.js:263', error);
    return false;
  }
};

// Check if payment is already in progress for this verification
export const hasActivePayment = async (verificationId) => {
  try {
    const paymentInfo = await getPaymentInfo(verificationId);
    if (!paymentInfo) return false;
    
    // Check if payment was made recently (within last 24 hours)
    const paymentTime = new Date(paymentInfo.timestamp);
    const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
    
    if (paymentTime > twentyFourHoursAgo) {
      // Payment exists and is recent, check its status
      if (paymentInfo.status === 'SUCCESSFULL') {
        return { hasPayment: true, status: 'COMPLETED', paymentInfo };
      } else if (paymentInfo.status === 'PENDING') {
        // Check with API to see if it's actually completed
        const statusResult = await checkPaymentStatus(paymentInfo.orderId);
        if (statusResult.success) {
          if (statusResult.data.status === 'SUCCESSFULL') {
            // Update local status
            paymentInfo.status = 'SUCCESSFULL';
            await storePaymentInfo(verificationId, paymentInfo);
            return { hasPayment: true, status: 'COMPLETED', paymentInfo };
          }
          return { hasPayment: true, status: statusResult.data.status, paymentInfo };
        }
      }
    }
    
    return { hasPayment: false };
  } catch (error) {
    console.error('Error checking active payment: - paymentService.js:299', error);
    return { hasPayment: false };
  }
};

// Get payment completion status
// export const getPaymentCompletionStatus = async (verificationId) => {
//   try {
//     const paymentInfo = await getPaymentInfo(verificationId);
//     if (!paymentInfo) return { completed: false };
    
//     // Always verify with Gloswitch API for the most accurate status
//     const statusResult = await checkPaymentStatus(paymentInfo.orderId);
//     if (statusResult.success) {
//       const currentStatus = statusResult.data.status;
      
//       // Update local storage if status changed
//       if (paymentInfo.status !== currentStatus) {
//         paymentInfo.status = currentStatus;
//         await storePaymentInfo(verificationId, paymentInfo);
//       }
      
//       return {
//         completed: currentStatus === 'SUCCESSFULL',
//         status: currentStatus,
//         paymentInfo: paymentInfo,
//         orderId: paymentInfo.orderId
//       };
//     }
    
//     // Fallback to local status if API check fails
//     return {
//       completed: paymentInfo.status === 'SUCCESSFULL',
//       status: paymentInfo.status,
//       paymentInfo: paymentInfo,
//       orderId: paymentInfo.orderId
//     };
//   } catch (error) {
//     console.error('Error getting payment completion: - paymentService.js:337', error);
//     return { completed: false };
//   }
// };

export const getPaymentCompletionStatus = async (verificationId) => {
  try {
    const resp = await api.get(`/verification/${verificationId}/payment-status`);
    return Boolean(resp.data?.isPaymentMade);
  } catch (err) {
    console.warn("Backend paymentstatus check failed: - paymentService.js:347", err?.message || err);
    return false;
  }
};
